import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { AiFillCloseCircle } from "react-icons/ai";

const AddFineModal = ({ onClose, checkin }) => {
  const [formData, setFormData] = useState({
    date: null,
    fineAmount: 0,
    reason: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!formData.date || !formData.fineAmount || !formData.reason) {
      return toast.error("Please fill all the fields");
    }
    setLoading(true);
    let config = {
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/check_in/add_fine/${checkin._id}`,
      data: formData,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        console.log("Response of handleSubmit: ", response.data);
        toast.success("Fine added successfully");
        onClose();
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in adding fine: ", error);
        toast.error(error.response.data.message);
      });
  };

  return (
    <div className="bg-black/50  backdrop-blur-sm fixed inset-0 w-full z-50 flex items-center justify-center min-h-screen">
      <div className="relative h-[30rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-3xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Add Fine</h2>
          <AiFillCloseCircle
            onClick={onClose}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        <form action="" className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Name  */}
          <div className="col-span-2">
            <label
              htmlFor=""
              className="block text-sm font-medium text-primaryTextColor"
            >
              Name
            </label>
            <input
              type="text"
              value={checkin.name}
              disabled
              className="mt-1 block w-full border rounded-md shadow-sm p-2 border-gray-300 bg-gray-100"
            />
          </div>

          {/* Date of Default  */}
          <div className="col-span-1">
            <label
              htmlFor=""
              className="block text-sm font-medium text-primaryTextColor"
            >
              Date of Default
            </label>
            <input
              type="date"
              f
              className="mt-1 block w-full border rounded-md shadow-sm p-2 border-gray-300 "
              value={formData.date}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  date: e.target.value,
                });
              }}
              onBlur={(e) => {
                const value = e.target.value;
                if (value) {
                  const selectedDate = new Date(value);
                  const today = new Date();
                  today.setHours(11, 59, 59, 59);

                  if (selectedDate > today) {
                    toast.error("Future dates are not alloweed");
                    e.target.value = "";
                    setFormData({
                      ...formData,
                      date: null,
                    });
                  }
                }
              }}
            />
          </div>

          {/* Fine Amount  */}
          <div className="col-span-1">
            <label
              htmlFor=""
              className="block text-sm font-medium text-primaryTextColor"
            >
              Fine Amount
            </label>
            <input
              type="text"
              placeholder="Enter fine amount"
              className="mt-1 block w-full border rounded-md shadow-sm p-2 border-gray-300 "
              onChange={(e) => {
                setFormData({
                  ...formData,
                  fineAmount: e.target.value,
                });
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
            />
          </div>

          {/* Reason */}
          <div className="col-span-2">
            <label
              htmlFor=""
              className="block text-sm font-medium text-primaryTextColor"
            >
              Reason
            </label>
            <textarea
              type="text"
              placeholder="Enter Reason"
              className="mt-1 block w-full resize-none border rounded-md shadow-sm p-2 border-gray-300 "
              onChange={(e) => {
                setFormData({
                  ...formData,
                  reason: e.target.value,
                });
              }}
            />
          </div>

          {/* Buttons  */}
          <div className="flex justify-between gap-6 mt-6 tracking-wide col-span-1 md:col-span-2">
            <button
              onClick={onClose}
              type="button"
              className="bg-white w-full border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              type="button"
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
              onClick={handleSubmit}
            >
              {loading ? "Submitting" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFineModal;
